import { forwardRef, Icon, IconProps } from '@chakra-ui/react';

const Trigger = forwardRef<IconProps, 'svg'>((props, ref) => (
  <Icon ref={ref} viewBox="0 0 16 16" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.8006 1.31291C10.1014 1.44451 10.2817 1.75651 10.2454 2.08286L9.83796 5.75004H13.5C13.7937 5.75004 14.0603 5.9214 14.1823 6.18851C14.3042 6.45562 14.2591 6.76933 14.0668 6.99123L7.56678 14.4912C7.35172 14.7394 7.00026 14.8188 6.69942 14.6872C6.39859 14.5556 6.21834 14.2436 6.2546 13.9172L6.66206 10.25H3.00001C2.70637 10.25 2.43974 10.0787 2.31777 9.81157C2.1958 9.54446 2.24093 9.23074 2.43324 9.00884L8.93324 1.50884C9.1483 1.2607 9.49976 1.18131 9.8006 1.31291ZM4.64248 8.75004H7.50001C7.71334 8.75004 7.91658 8.84089 8.05886 8.99985C8.20113 9.15881 8.26898 9.37083 8.24542 9.58286L8.01155 11.6877L11.8575 7.25004H9.00001C8.78668 7.25004 8.58344 7.15919 8.44117 7.00023C8.29889 6.84127 8.23104 6.62924 8.2546 6.41721L8.48847 4.31236L4.64248 8.75004Z"
      fill="currentColor"
    />
  </Icon>
));

export default Trigger;
